
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","fill":"#00f","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"loading-indicator_svg__b","d":"M33.64 32.386a2.032 2.032 0 01-2.827.08 1.926 1.926 0 01-.082-2.765C32.818 27.537 34 24.686 34 21.65c0-6.482-5.373-11.737-12-11.737S10 15.167 10 21.65c0 1.08-.895 1.956-2 1.956s-2-.875-2-1.956C6 13.006 13.163 6 22 6s16 7.006 16 15.65c0 4.044-1.578 7.852-4.36 10.736z"}}),_c('path',{attrs:{"id":"loading-indicator_svg__a","d":"M22 38c-8.837 0-16-7.163-16-16S13.163 6 22 6s16 7.163 16 16-7.163 16-16 16zm0-4c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#D0D0D0","fill-rule":"nonzero","xlink:href":"#loading-indicator_svg__a"}}),_c('mask',{attrs:{"id":"loading-indicator_svg__c","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#loading-indicator_svg__b"}})]),_c('use',{attrs:{"fill":"#4B4B4B","fill-rule":"nonzero","xlink:href":"#loading-indicator_svg__b"}}),_c('g',{attrs:{"mask":"url(#loading-indicator_svg__c)"}},[_c('path',{attrs:{"d":"M0 0h44v44H0z"}})])])])
          )
        }
      }
    